import { boolean } from 'yup';

export const termsValidationSchema = boolean().oneOf(
  [true],
  'You must agree to our terms of service and privacy policy.',
);
